<template>
  <vx-card no-shadow>
    <div id="editClubBookingFeedbackLoadingDiv" class="vs-con-loading__container ">
      <div class="vx-row mt-2 mx-1" v-for="(bookingFeedback, index) in feedbacks" :key="index">
        	<div class="vx-col sm:w-full w-full mb-5">
          	<vx-card title="">
          		<template   slot="actions">
	              <feather-icon @click="removeField(index)" icon="XIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
	            </template>

              <vx-input-group class="">
				      	<template slot="append">
					        <div class="append-text bg-grey">
		                <vs-switch color="primary" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" v-model="bookingFeedback.answer_type_bool">
                    <span slot="on">Text</span>
                    <span slot="off">Emoji</span>
                </vs-switch>

					        </div>
				      	</template>
		      			<vs-input v-validate="'required'" :name="'feedback_question_'+index" :ref="'feedback_question_'+index" v-model="bookingFeedback.question" />
		    		</vx-input-group>
		    		<span class="text-danger text-sm" v-show="errors.has('feedback_question_'+index)">This field is required</span>
          </vx-card>
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="flex flex-wrap items-center justify-end vx-row mt-2 mx-1">
        <vs-button @click="addNewField()" class="ml-4 mt-2" >Add field</vs-button>
        <vs-button @click="validateData()" class="ml-4 mt-2">Save Changes</vs-button>
      </div>
    </div>
  </vx-card>
</template>

<script>
import VueDawa from '@ancaio/vue-dawa/sfc'
import moduleClubManagement from '@/store/club-management/moduleClubManagement.js'

export default {
  	components: {
    	VueDawa,
  	},
  	data() {
	    return {
	      feedbacks : [],
	    }
  	},
  	computed: {

  	},
  	methods: {
  		removeField(index) {
        this.feedbacks.splice(index, 1);
      },
	    addNewField() {
	      this.feedbacks.push({ question : "", answer_type : "text", answer_type_bool : false, feedback_type : "student_bookings"})
	    },
	    validateData() {
	      this.$validator.validateAll().then(result => {
	        if (result && this.feedbacks.length) this.updateFeedbackData()
	      })
	    },
	    updateFeedbackData() {
	      var self = this
	      
	      this.$vs.loading({
	        container: '#editClubBookingFeedbackLoadingDiv',
	        scale: 0.6
	      })

	      let feedbackData = [];

	      for(var i = 0; this.feedbacks.length > i; i++){
	      	feedbackData.push({
	      		answer_type : this.feedbacks[i].answer_type_bool == true ? "text" : "emoji",
	      		feedback_type : "student_bookings",
	      		question : this.feedbacks[i].question
	      	})
	      }

	      let data = {feedbacks : feedbackData}

	      this.$store.dispatch("clubManagement/manageFeedback", data)
	        .then(res => { 
	            this.$vs.loading.close('#editClubBookingFeedbackLoadingDiv > .con-vs-loading')

	            this.$vs.notify({
	                title: "Success.",
	                text: "Feedback updated successfully.",
	                iconPack: "feather",
	                icon: "icon-alert-circle",
	                color: "success"
	            });
	        })
	        .catch(err => { 
	          if(err.status && err.status == 422){
	            Object.keys(err.data).forEach(function(key) {
	              self.errors.add({
	                field: key,
	                msg: err.data[key][0],
	              });
	            });
	          }

	          this.$vs.loading.close('#editClubBookingFeedbackLoadingDiv > .con-vs-loading')
	        })

	    },
	    getFeedbackData() {
	      this.$store.dispatch("clubManagement/getFeedbackData")
	        .then(res => { 
	        	for(var i = 0; res.data.length > i; i++){
	        		res.data[i].answer_type_bool = res.data[i].answer_type == "text" ? true : false
			      }

	          this.feedbacks = res.data
	        })
	        .catch(err => { })
	    },
  	},
  	created() {
	    if(!moduleClubManagement.isRegistered) {
	        this.$store.registerModule('clubManagement', moduleClubManagement)
	        moduleClubManagement.isRegistered = true
	    }

    	this.getFeedbackData()
  	},
}
</script>
